"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var formatLargeNumber = function formatLargeNumber(_ref) {
  var number = _ref.number;

  if (!Number.isInteger(number)) {
    return '';
  }

  if (number >= 1000) {
    return Math.round(number / 1000) + 'k';
  }

  return number.toString();
};

var _default = formatLargeNumber;
exports["default"] = _default;
//# sourceMappingURL=formatLargeNumber.js.map